import {
  deleteSingleServiceProvider,
  fetchSingleServiceProvider
} from 'Services/ServiceProviderManagement/Features/ServiceProvider/serviceProviderSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { useEffect } from 'react'

function useSingleServiceProvider(id: string | undefined) {
  const dispatch = useAppDispatch()
  const { singleServiceProvider, singleLoading, submitLoading, deleteLoading } = useTypedSelector(
    state => state.serviceProvider
  )

  useEffect(() => {
    if (!id) return
    dispatch(fetchSingleServiceProvider({ id }))
  }, [id])

  const deleteServiceProvider = (id: string) => {
    return dispatch(deleteSingleServiceProvider({ id }))
  }

  return {
    singleServiceProvider,
    singleLoading,
    submitLoading,
    deleteServiceProvider,
    deleteLoading
  }
}

export default useSingleServiceProvider
